module.exports = __webpack_public_path__ + "img/Stoferno.gr-Live-Tracking-on-Computer-Asset.6661ca17.png";